import React from "react";

const SuccessIcon = () => {
  return (
    <div className="success-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="82"
        height="82"
        viewBox="0 0 82 82"
        fill="none"
      >
        <path
          d="M41 71.75C57.9828 71.75 71.75 57.9828 71.75 41C71.75 24.0172 57.9828 10.25 41 10.25C24.0172 10.25 10.25 24.0172 10.25 41C10.25 57.9828 24.0172 71.75 41 71.75Z"
          stroke="#EA6B3D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.75 41L37.5833 47.8333L51.25 34.1666"
          stroke="#EA6B3D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default SuccessIcon;
